module.exports = __webpack_public_path__ + "img/thumbnail.b9ff1fc7.png";